import ToolOption from '../common/ToolOption';
import { CanvasEventType } from './../constants/Constants';
import Graphic from './Graphic';

/**
 *
 * Created Date: 2019-03-27, 19:57:21 (zhenliang.sun)
 * Last Modified: 2019-06-14, 19:20:16 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

/**
 * 标准三角形的基类
 *
 * @export
 * @class CanvasTriangleBase
 * @extends {Graphic}
 * @author zhenliang.sun
 */
export default class CanvasTriangleBase extends Graphic {
  constructor(app) {
    super(app);
    this._triangle = null;
    this._isMouseDown = false;
    this.ox = 0;
    this.oy = 0;

    this.e = {
      mouseDown: this._mouseDownHandler.bind(this),
      mouseMove: this._mouseMoveHandler.bind(this),
      mouseUp: this._mouseUpHandler.bind(this)
    };
  }

  get option() {
    return this._option;
  }

  set option(val) {
    super.option = val;

    if (!val) {
      this._option = this.defaultOption;
    }

    Object.assign(this._option, val);
  }

  get defaultOption() {
    return new ToolOption();
  }

  addEvents() {
    super.addEvents();
    this.root.on(CanvasEventType.MouseDown, this.e.mouseDown);

    this.root.on(CanvasEventType.MouseMove, this.e.mouseMove);

    this.root.on(CanvasEventType.MouseUp, this.e.mouseUp);
  }

  removeEvents() {
    super.removeEvents();
    this.root.off(CanvasEventType.MouseDown, this.e.mouseDown);
    this.root.off(CanvasEventType.MouseMove, this.e.mouseMove);
    this.root.off(CanvasEventType.MouseUp, this.e.mouseUp);
  }

  static toAddData(target) {
    let obj = Graphic.toAddData(target);
    obj.fill = '';
    return obj;
  }

  _mouseDownHandler(o) {
    this._isMouseDown = true;
    let sp = this.root.getPointer(o.e);
    this.ox = +sp.x.toFixed(1);
    this.oy = +sp.y.toFixed(1);
  }
  _mouseMoveHandler(o) {}
  _mouseUpHandler(o) {
    this._isMouseDown = false;
  }
}
